import React from 'react';
import PropTypes from 'prop-types';

import withRsSlidableNavigationHandlers from '@Pages/RetroSynthesis/components/RsSlidable/HOCs/withSlidableNavigationHandlers';
import RsSlidableNavigationPrev from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationPrev';
import RsSlidableNavigationNext from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidableNavigationNext';

function PrevNavigation({ prevDisabled, goPrev }) {
  return (
    <div className="rs-slidable-navigation rs-slidable-navigation--both-sides rs-slidable-navigation--prev">
      <RsSlidableNavigationPrev disabled={prevDisabled} onClick={goPrev} />
    </div>
  );
}

PrevNavigation.propTypes = {
  prevDisabled: PropTypes.bool,
  goPrev: PropTypes.func,
};

function NextNavigation({ nextDisabled, goNext }) {
  return (
    <div className="rs-slidable-navigation rs-slidable-navigation--both-sides rs-slidable-navigation--next">
      <RsSlidableNavigationNext disabled={nextDisabled} onClick={goNext} />
    </div>
  );
}

NextNavigation.propTypes = {
  nextDisabled: PropTypes.bool,
  goNext: PropTypes.func,
};

export const PrevNavigationWithHandlers = withRsSlidableNavigationHandlers()(PrevNavigation);
export const NextNavigationWithHandlers = withRsSlidableNavigationHandlers()(NextNavigation);
